var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3 py-1.5 px-3 rounded-md bg-blue-50 dark:bg-blue-900/20 text-xs text-blue-800 dark:text-blue-200 flex items-center gap-1.5"},[_c('fluent-icon',{attrs:{"icon":"info","size":"14"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.message || _vm.$t('AOIKUMO_READ_ONLY.BANNER_MESSAGE')))])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }